import { useDispatch, useSelector } from "react-redux";
import {
  selectAuth,
  selectUserRoles,
} from "../../SharedModule/redux/reducers/auth.reducer";
import { TelerikReport } from "../../SharedModule/components/TelerikReport";
import { getHostUrl } from "../../ProductsModule/utils/reportsUtils";
import { setActiveTab } from "../../SharedModule/redux/reducers/uiShared.reducer";
import { useEffect } from "react";
import { Spinner } from "../../SharedModule/components/Spinner";
import {
  ROUTE_USERS_BAMBOO_PROFILE,
  USERS_ADMIN_ACCESS,
} from "../../SharedModule/utils/constants";
import { verifyModuleAccess } from "../../SharedModule/utils/accessUtils";
import { ForbiddenPage } from "../../SharedModule/pages/ForbiddenPage";

export const BambooProfileImportReportPage = () => {
  const dispatch = useDispatch();
  const auth = useSelector(selectAuth);

  // to help telerik reports to get correct local timezone
  const today = new Date();
  const importDate = new Date(
    Date.UTC(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
      today.getHours(),
      today.getMinutes(),
      today.getSeconds()
    )
  );
  let parameters = {
    HostUrl: getHostUrl(),
    Auth: auth.accessToken,
    ImportDate: importDate,
  };

  const { userRolesList, rolesLoaded } = useSelector(selectUserRoles);

  useEffect(() => {
    document.title = "The Hub - BambooHR Profile Import Report";
    dispatch(setActiveTab(ROUTE_USERS_BAMBOO_PROFILE));
  }, []);

  return (
    <>
      {!rolesLoaded && (
        <Spinner
          style={{
            marginLeft: "50%",
            marginTop: "5%",
          }}
        />
      )}
      {rolesLoaded &&
        !verifyModuleAccess(true, USERS_ADMIN_ACCESS, userRolesList) && (
          <ForbiddenPage />
        )}
      {rolesLoaded &&
        verifyModuleAccess(true, USERS_ADMIN_ACCESS, userRolesList) && (
          <TelerikReport
            title="BambooHR Profile Import report"
            reportName="BambooProfileImport.trdp"
            parameters={parameters}
            parametersAreaVisible={true}
          />
        )}
    </>
  );
};
